import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react';
import qs from 'query-string';

import getEnvConfig from '../../../../../utils/config/env';
import {
    BroadcastProps,
    BroadcastsProps,
} from '../../massBroadcasts/service/broadcasts.interface';
import { AutoBroadcastValues } from './autoBroadcast.interface';

export const autoBroadcastsApi = createApi({
    reducerPath: 'autoBroadcasts',
    baseQuery: fetchBaseQuery({
        baseUrl: getEnvConfig().env.API_URL,
        prepareHeaders: headers => {
            const token = localStorage.getItem('accessToken');
            headers.set('Authorization', `Bearer ${token}`);
            return headers;
        },
    }),
    tagTypes: ['AutoBroadcasts'],

    endpoints: builder => ({
        readAutoBroadcast: builder.query({
            query: shop_id => {
                return {
                    url: `/shops/${shop_id}/autobroadcasts/settings`,
                    method: 'GET',
                };
            },
            transformResponse: (res: { data: AutoBroadcastValues[] }) => {
                return res.data;
            },
            providesTags: ['AutoBroadcasts'],
        }),

        readAutoBroadcasts: builder.query({
            query: ({ filters, id }) => {
                const queryArgs = qs.stringify(filters, {
                    arrayFormat: 'bracket',
                    skipEmptyString: true,
                    skipNull: true,
                });
                return {
                    url: `/shops/${id}/broadcasts-statistic?${queryArgs}`,
                };
            },
            transformResponse: (response: { data: BroadcastProps[] }, meta) => {
                return {
                    items: response.data || [],
                    total:
                        Number(meta.response.headers.get('Items-Count')) || 0,
                };
            },

            providesTags: ['AutoBroadcasts'],
        }),

        createAutoBroadcastSettings: builder.mutation({
            query: ({ shop_id, payload }) => ({
                url: `/shops/${shop_id}/autobroadcasts/settings`,
                body: payload,
                method: 'POST',
            }),
            invalidatesTags: ['AutoBroadcasts'],
        }),

        updateAutoBroadcastSettings: builder.mutation({
            query: ({ shop_id, body }) => ({
                url: `/shops/${shop_id}/autobroadcasts/settings`,
                body: body,
                method: 'PUT',
            }),
            invalidatesTags: ['AutoBroadcasts'],
        }),

        updateAutoBroadcastMessage: builder.mutation({
            query: ({ shop_id, body }) => ({
                url: `/shops/${shop_id}/autobroadcasts`,
                body: body,
                method: 'POST',
            }),
            invalidatesTags: ['AutoBroadcasts'],
        }),
    }),
});

export const {
    useLazyReadAutoBroadcastQuery,
    useLazyReadAutoBroadcastsQuery,

    useCreateAutoBroadcastSettingsMutation,
} = autoBroadcastsApi;
